<template>
  <div>
    <div class="navbar-wrapper">
      <Navbar
        minimal
        is-webshop
        hide-cart
        hide-shadow
        :wallet-amount="spaazaUser.amount"
        :cart="cart"
        :logo-link="logoLink"
        :login-link="loginLink"
        :account-link="accountLink"
        :menu-items="menuItems"
        :language-dropdown-settings="languageDropdownSettings"
        :country-dropdown-settings="countryDropdownSettings"
        :account-dropdown-settings="accountDropdownSettings"
        :user="user"
        :user-authenticated="isAuthenticated"
        @logout="logout"
      />
    </div>
    <div class="no-padding-container container">
      <div
        class="content-container flex flex-col md:pt-6 md:pb-40"
        :class="{ 'justify-center': isCartEmpty }"
      >
        <div
          v-if="!isCartEmpty"
          class="left-flex flex-1"
        >
          <WebshopCheckoutHeader :active-index="activeIndex" />
          <div class="pt-9 lg:pt-10">
            <nuxt />
          </div>
        </div>
        <div class="right-flex pb-40">
          <WebshopCart
            class="h-auto"
            v-bind="cartProps"
            @close="toggleOCP(false)"
            @plus="addOneItemQuantity"
            @minus="removeOneItemQuantity"
            @activate="$router.push($i18n.localePath({ name: 'account-memberships' }))"
            @remove="removeCartItem({ productId: $event.productId })"
          >
            <div class="pt-7">
              <OButton
                variant="secondary"
                @click="$router.push($i18n.localePath({ name: 'webshop' }))"
              >
                {{ $t('Loyalty.LoyaltyProgram.ShopForGoodies') }}
              </OButton>
            </div>
          </WebshopCart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authenticated } from '@/mixins/layouts'
import spaazaMixin from '@/mixins/spaaza'
import webshopMixin from '@/mixins/webshop'
import Navbar from '@/components/Navbar/Navbar'
import WebshopCheckoutHeader from '@/components/Webshop/WebshopCheckoutHeader'
import WebshopCart from '@/components/Webshop/WebshopCart'
import OButton from '@/components/OButton'
import { CartTypes } from '@/enums/webshop'

export default {
  name: 'LayoutWebshop',
  middleware: 'homepage',
  components: { Navbar, WebshopCheckoutHeader, WebshopCart, OButton },
  mixins: [authenticated, spaazaMixin, webshopMixin],
  async fetch () {
    try {
      await Promise.all([
        this.getSpaazaUser(),
        this.getSpaazaWallet(),
        this.getAndSetShippingDetails(),
        this.getAndSetMemberStats()
      ])
    } catch (error) {
      this.$ota.general.logError(error)
    }
  },
  computed: {
    activeIndex () {
      if (this.$route.path.includes('webshop/checkout/payment')) {
        return 1
      }

      if (this.$route.path.includes('webshop/checkout/confirmation')) {
        return 2
      }

      return 0
    },
    cartProps () {
      return {
        type: CartTypes.Checkout,
        cart: this.cart,
        country: this.country,
        receiptProps: this.receiptProps,
        totalCartItems: this.totalCartItems,
        isWalletFrozen: this.isWalletFrozen
      }
    },
    isCartEmpty () {
      return this.totalCartItems <= 0
    }
  },
  head () {
    return {
      script: [
        {
          hid: 'webshop-gtm',
          innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-M73VTJX');`,
          type: 'text/javascript'
        }
      ],
      __dangerouslyDisableSanitizersByTagID: {
        'webshop-gtm': ['innerHTML']
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.h-auto {
  height: auto;
}

@screen lg {
  .content-container {
    @apply flex-row;

    .right-flex {
      @apply pt-1 ml-10;
      min-width: 41.2rem;
    }
  }
}
</style>
